import useModal from 'src/components/Modals/hooks/useModal';
import FeatureAnnouncementModal from 'src/components/Modals/FeatureAnnouncementModal/FeatureAnnouncementModal';

export default function AnnouncementModals() {
	const { currentModal } = useModal();

	return (
		<>
			{currentModal?.type === 'feature_announcement' && (
				<FeatureAnnouncementModal {...currentModal.props} />
			)}
		</>
	);
}
